<script setup lang="ts">
import { ref, onBeforeUnmount } from 'vue';
import { Offcanvas } from 'bootstrap';
import { useUxData } from '@/stores/ux-data';
import { teardownOffcanvas } from '@/composables/useOffcanvas';

defineProps<{ active?: boolean }>();
const emit = defineEmits<{ clear: [] }>();

const ux = useUxData();
const root = ref<HTMLElement | null>(null);

const open = () => { if (root.value) Offcanvas.getOrCreateInstance(root.value).show(); };
const close = () => { if (root.value) Offcanvas.getInstance(root.value)?.hide(); };

// The drawer can still be open (mobile) when the list goes away. See teardownOffcanvas for why
// that takes more than a dispose(), and why it cannot wait for onUnmounted.
onBeforeUnmount(() => teardownOffcanvas(root.value));
defineExpose({ open, close });
</script>

<template>
  <div ref="root" class="filter-bar offcanvas-lg offcanvas-end" tabindex="-1" aria-labelledby="filter-bar-title">
    <!-- Leading filter glyph — shown only for .element-grid lists at lg+ (see _filter-bar.scss). -->
    <span class="fa-light fa-filter-list filter-bar-icon" aria-hidden="true"></span>
    <div class="offcanvas-header d-lg-none">
      <h6 id="filter-bar-title" class="offcanvas-title">{{ (ux.labels as any)?.filters?.title ?? 'Filters' }}</h6>
      <button type="button" class="btn-close" :aria-label="(ux.labels as any)?.actions?.close ?? 'Close'" @click="close"></button>
    </div>
    <div class="offcanvas-body d-flex flex-wrap gap-2 align-items-center">
      <slot />
      <button v-if="active" type="button" class="btn btn-link btn-sm filter-bar-clear ms-lg-auto" @click="emit('clear')">
        {{ (ux.labels as any)?.filters?.clear ?? 'Clear filters' }}
      </button>
    </div>
  </div>
</template>
